import { Col, Form, Row } from 'react-bootstrap';
import { useState, useEffect } from "react";
import MultiSelectDropDownInput from '../CommonComponents/MultiSelectDropDownComponent/MultiSelectDropDownInput';
import { EXEC_TITLES, FILTER_MNEMONICS, GICS_INDUSTRIES, GICS_SECTORS } from '../Constants';
import GroupVisibleComponent from '../GroupVisibleComponent';
import { USER_GROUPS } from '../utils/AuthUtils';


const financialIndices = [FILTER_MNEMONICS.REVENUE, FILTER_MNEMONICS.MARKET_CAP, FILTER_MNEMONICS.MARKET_CAP_AVG, FILTER_MNEMONICS.TOTAL_ASSETS, FILTER_MNEMONICS.TOTAL_EMPLOYEES];
const maxUpperBound = 999999999;
const defaultFinancialFilter = {
    primaryLowerBound: 0,
    primaryUpperBound: maxUpperBound,
    filterOperator: "",
    secondaryLowerBound: 0,
    secondaryUpperBound: maxUpperBound
};

export default function TemplateFilters({ disabled, filters, handleFilteringOptions, handleFilterUpdate, findMatchingOptions, toggleMultiSelectedOptions, selectedTemplateId, index, handleSetIndex, financialFilter, handleSetFinancilFilter, primaryFilterInvalid, secondaryFilterInvalid, sectorOptions, industryOptions, handleFilteringIndustryOptions, handleFilteringSectorOptions, handleIndustryUpdate, handleSectorUpdate, toggleMultiSelectedIndustryOptions, toggleMultiSelectedSectorOptions, findMatchingSectorOptions, findMatchingIndustryOptions }) {
    const [gicsCodeType, setGicsCodeType] = useState("");
    const [primaryLowerBoundDisplay, setPrimaryLowerBoundDisplay] = useState("");
    const [primaryUpperBoundDisplay, setPrimaryUpperBoundDisplay] = useState("");
    const [secondaryLowerBoundDisplay, setSecondaryLowerBoundDisplay] = useState("");
    const [secondaryUpperBoundDisplay, setSecondaryUpperBoundDisplay] = useState("");

    const handleNumberInput = (value) => {
        let val = parseInt(value);
        val = val >= 0 ? val : 0;
        return val;
    }

    const handleChangeIndex = (value) => {
        if (value === "" || !financialIndices.includes(value)) {
            handleSetFinancilFilter(defaultFinancialFilter);
            setPrimaryLowerBoundDisplay("");
            setPrimaryUpperBoundDisplay("");
            setSecondaryLowerBoundDisplay("");
            setSecondaryUpperBoundDisplay("");
        }
        handleSetIndex(value);
    }

    const handleSetFilterOperator = (value) => {
        if (value === "") {
            handleSetFinancilFilter({ ...financialFilter, filterOperator: value, secondaryLowerBound: 0, secondaryUpperBound: maxUpperBound });
            setSecondaryLowerBoundDisplay("");
            setSecondaryUpperBoundDisplay("");
        } else {
            handleSetFinancilFilter({ ...financialFilter, filterOperator: value })
        }
    }

    const handleSetPrimaryUpperBound = (value) => {
        const strValue = value.replace(/,/g, '');
        if (isNaN(Number(strValue))) {
            return;
        }
        const numVal = handleNumberInput(strValue);
        if (numVal === 0) {
            setPrimaryUpperBoundDisplay("")
            handleSetFinancilFilter({ ...financialFilter, primaryUpperBound: maxUpperBound });
        } else {
            setPrimaryUpperBoundDisplay(numVal.toLocaleString());
            handleSetFinancilFilter({ ...financialFilter, primaryUpperBound: numVal });
        }
    }

    const handleSetPrimaryLowerBound = (value) => {
        const strValue = value.replace(/,/g, '');
        if (isNaN(Number(strValue))) {
            return;
        }
        const numVal = handleNumberInput(strValue);
        setPrimaryLowerBoundDisplay(numVal.toLocaleString());
        handleSetFinancilFilter({ ...financialFilter, primaryLowerBound: numVal });
    }

    const handleSetSecondaryUpperBound = (value) => {
        const strValue = value.replace(/,/g, '');
        if (isNaN(Number(strValue))) {
            return;
        }
        const numVal = handleNumberInput(strValue);
        if (numVal === 0) {
            setSecondaryUpperBoundDisplay("")
            handleSetFinancilFilter({ ...financialFilter, secondaryUpperBound: maxUpperBound });
        } else {
            setSecondaryUpperBoundDisplay(numVal.toLocaleString());
            handleSetFinancilFilter({ ...financialFilter, secondaryUpperBound: numVal });
        }
    }

    const handleSetSecondaryLowerBound = (value) => {
        const strValue = value.replace(/,/g, '');
        if (isNaN(Number(strValue))) {
            return;
        }
        const numVal = handleNumberInput(strValue);
        setSecondaryLowerBoundDisplay(numVal.toLocaleString());
        handleSetFinancilFilter({ ...financialFilter, secondaryLowerBound: numVal });
    }

    const handleSetGICSCodeType = (value) => {
        if (value === "Industry") {
            handleSectorUpdate([]);
        } else if (value === "Sector") {
            handleIndustryUpdate([]);
        } else {
            handleSectorUpdate([]);
            handleIndustryUpdate([]);
        }
        setGicsCodeType(value);
    }

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            if (!index) {
                handleSectorUpdate([]);
                handleIndustryUpdate([]);
            }
        }
        return () => isSubscribed = false;
    }, [index, handleSectorUpdate, handleIndustryUpdate]);

    return (
        <>
            {selectedTemplateId && selectedTemplateId !== "" ?
                <div>
                    <Row className="mt-1 pb-2">
                        {filters.length > 0 && <>{filters.slice(0, 4).map((filter, index) => <Col md={3} key={filter.fieldName}>
                            <Form.Group controlId={filter.fieldName}>
                                <Form.Label>
                                    <span>{filter.fieldName}</span>
                                </Form.Label>
                                <MultiSelectDropDownInput
                                    disabled={disabled}
                                    options={filter.options}
                                    toggleOption={({ id }) => toggleMultiSelectedOptions(id, filter)}
                                    clearAll={() => handleFilterUpdate(filter, [])}
                                    optionSearch={option => {
                                        if (option === null) return;

                                        if (option === "") {
                                            handleFilteringOptions(filter, EXEC_TITLES);
                                            return;
                                        }

                                        option = option.trim();
                                        const optionLower = option.toLowerCase();
                                        const matchedOptions = findMatchingOptions(optionLower, filter.options);
                                        handleFilteringOptions(filter, matchedOptions);
                                    }} />
                            </Form.Group>
                        </Col>)}</>}
                        <Col md={2}>
                            <Form.Group controlId='index'>
                                <Form.Label>
                                    Filter
                                </Form.Label>
                                <Form.Select
                                    value={index}
                                    onChange={(e) => handleChangeIndex(e.target.value)}
                                >
                                    <option value={''}>No Filter</option>
                                    <GroupVisibleComponent groups={[USER_GROUPS.ADMIN, USER_GROUPS.INTERNAL]}>
                                        <option value={FILTER_MNEMONICS.SP500_INDEX}>S&P 500</option>
                                        <option value={FILTER_MNEMONICS.SP1500_INDEX}>S&P 1500</option>
                                        <option value={FILTER_MNEMONICS.SP400_INDEX}>S&P 400</option>
                                        <option value={FILTER_MNEMONICS.RUSSELL3000_INDEX}>Russell 3000</option>
                                        <option value={FILTER_MNEMONICS.NAREIT_INDEX}>NAREIT</option>
                                    </GroupVisibleComponent>
                                    <option value={FILTER_MNEMONICS.REVENUE}>Revenue (LTM)</option>
                                    <option value={FILTER_MNEMONICS.MARKET_CAP}>Market Cap (End of Month)</option>
                                    <option value={FILTER_MNEMONICS.MARKET_CAP_AVG}>Market Cap 12M Rolling Avg</option>
                                    <option value={FILTER_MNEMONICS.TOTAL_ASSETS}>Total Assets (LTM)</option>
                                    <option value={FILTER_MNEMONICS.TOTAL_EMPLOYEES}>Total Employees (LTM)</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {financialIndices.includes(index) && <><Col md={3}>
                            <Form.Group controlId="primaryLowerBound">
                                <Form.Label>{index === FILTER_MNEMONICS.TOTAL_EMPLOYEES ? "Lower Bound" : "Lower Bound ($M)"}</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={primaryLowerBoundDisplay}
                                    onChange={(e) => handleSetPrimaryLowerBound(e.target.value)}
                                    isInvalid={primaryFilterInvalid}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Upper Bound must be less than Lower Bound
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                            <Col md={3}>
                                <Form.Group controlId="primaryUpperBound">
                                    <Form.Label>{index === FILTER_MNEMONICS.TOTAL_EMPLOYEES ? "Upper Bound" : "Upper Bound ($M)"}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={primaryUpperBoundDisplay}
                                        onChange={(e) => handleSetPrimaryUpperBound(e.target.value)}
                                        isInvalid={primaryFilterInvalid}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Upper Bound must be less than Lower Bound
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="filterOperator">
                                    <Form.Label>Secondary Filter</Form.Label>
                                    <Form.Select
                                        as="select"
                                        value={financialFilter.filterOperator}
                                        onChange={(e) => handleSetFilterOperator(e.target.value)}
                                    >
                                        <option value="">No Secondary Filter</option>
                                        <option value="AND">And</option>
                                        <option value="OR">Or</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {financialIndices.includes(index) && financialFilter.filterOperator && <><Col md={2}>
                                <Form.Group controlId="secondaryFilterType">
                                    <Form.Label>Secondary Filter</Form.Label>
                                    <Form.Select
                                        as="select"
                                        value={financialFilter.secondaryFilterType}
                                        onChange={(e) => handleSetFinancilFilter({ ...financialFilter, secondaryFilterType: e.target.value })}
                                    >
                                        <option value={""}>Select Filter</option>
                                        <option value={FILTER_MNEMONICS.REVENUE}>Revenue (LTM)</option>
                                        <option value={FILTER_MNEMONICS.MARKET_CAP}>Market Cap (End of Month)</option>
                                        <option value={FILTER_MNEMONICS.MARKET_CAP_AVG}>Market Cap Rolling Avg</option>
                                        <option value={FILTER_MNEMONICS.TOTAL_ASSETS}>Total Assets (LTM)</option>
                                        <option value={FILTER_MNEMONICS.TOTAL_EMPLOYEES}>Total Employees (LTM)</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                                <Col md={3}>
                                    <Form.Group controlId="secondaryLowerBound">
                                        <Form.Label>{financialFilter.secondaryFilterType === FILTER_MNEMONICS.TOTAL_EMPLOYEES ? "Lower Bound" : "Lower Bound ($M)"}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={secondaryLowerBoundDisplay}
                                            onChange={(e) => handleSetSecondaryLowerBound(e.target.value)}
                                            isInvalid={secondaryFilterInvalid}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Upper Bound must be less than Lower Bound
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group controlId="secondaryUpperBound">
                                        <Form.Label>{financialFilter.secondaryFilterType === FILTER_MNEMONICS.TOTAL_EMPLOYEES ? "Upper Bound" : "Upper Bound ($M)"}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={secondaryUpperBoundDisplay}
                                            onChange={(e) => handleSetSecondaryUpperBound(e.target.value)}
                                            isInvalid={secondaryFilterInvalid}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Upper Bound must be less than Lower Bound
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col></>}</>}
                        {index?.length > 0 && <>
                            <GroupVisibleComponent groups={[USER_GROUPS.ADMIN, USER_GROUPS.INTERNAL]}>
                                <Col md={2}>
                                    <Form.Group conrolId='gics-code'>
                                        <Form.Label>
                                            GICS code
                                        </Form.Label>
                                        <Form.Select
                                            value={gicsCodeType}
                                            onChange={(e) => handleSetGICSCodeType(e.target.value)}
                                        >
                                            <option value={''}>No GICS Code</option>
                                            <option value={"Industry"}>Industry</option>
                                            <option value={"Sector"}>Sector</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {gicsCodeType === "Industry" && <Col md={4}>
                                    <Form.Group conrolId='gics-code'>
                                        <Form.Label>
                                            Industry
                                        </Form.Label>
                                        <MultiSelectDropDownInput
                                            disabled={disabled}
                                            options={industryOptions}
                                            toggleOption={({ id }) => toggleMultiSelectedIndustryOptions(id)}
                                            clearAll={() => handleIndustryUpdate([])}
                                            optionSearch={option => {
                                                if (option === null) return;

                                                if (option === "") {
                                                    handleFilteringIndustryOptions(GICS_INDUSTRIES);
                                                    return;
                                                }

                                                option = option.trim();
                                                const optionLower = option.toLowerCase();
                                                const matchedOptions = findMatchingIndustryOptions(optionLower);
                                                handleFilteringIndustryOptions(matchedOptions);
                                            }} />
                                    </Form.Group>
                                </Col>}
                                {gicsCodeType === "Sector" && <Col md={4}>
                                    <Form.Group conrolId='gics-code'>
                                        <Form.Label>
                                            Sector
                                        </Form.Label>
                                        <MultiSelectDropDownInput
                                            disabled={disabled}
                                            options={sectorOptions}
                                            toggleOption={({ id }) => toggleMultiSelectedSectorOptions(id)}
                                            clearAll={() => handleSectorUpdate([])}
                                            optionSearch={option => {
                                                if (option === null) return;

                                                if (option === "") {
                                                    handleFilteringSectorOptions(GICS_SECTORS);
                                                    return;
                                                }

                                                option = option.trim();
                                                const optionLower = option.toLowerCase();
                                                const matchedOptions = findMatchingSectorOptions(optionLower);
                                                handleFilteringSectorOptions(matchedOptions);
                                            }} />
                                    </Form.Group>
                                </Col>}
                            </GroupVisibleComponent>
                        </>}
                    </Row>
                    {filters.length > 4 &&
                        <Row>
                            {filters.slice(4).map(filter => (
                                <Col md={4} key={filter.fieldName}>
                                    <Form.Group controlId={filter.fieldName}>
                                        <Form.Label>{filter.fieldName}</Form.Label>
                                        <Form.Control as="select" onChange={(e) => handleFilterUpdate(filter, e.target.value)} disabled={disabled}>
                                            <option>Loading...</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>))}
                        </Row>}
                </div> : ""}
        </>);
}
